import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  mr: {
    appTitle: "संपूर्ण संग्रह",
    appSubtitle: "आध्यात्मिक वाचनाचा संपूर्ण संग्रह",
    homeTab: "होम",
    searchTab: "शोधा",
    jaapTab: "जप",
    favTab: "आवडते",
    settingsTab: "सेटिंग्ज",
    historyTab: "इतिहास",
    settingsHeader: "सेटिंग्ज",
    langLabel: "भाषा (Language)",
    themeLabel: "थीम (Theme)",
    themeLight: "☀️ प्रकाश (Light)",
    themeDark: "🌙 अंधार (Dark)",
    elderModeLabel: "ज्येष्ठ नागरिक मोड (Elder Mode)",
    elderModeHelp: "मोठा मजकूर, मोठे बटण आणि अधिक जागा सक्षम करा.",
    fontSizeLabel: "अक्षर आकार (Font Size)",
    scrollSpeedLabel: "स्वयंचलित स्क्रोल गती",
    offlineLabel: "ऑफलाइन व्यवस्थापन",
    offlineHelp: "✅ ऑफलाइन उपलब्ध",
    exportLabel: "डेटा निर्यात करा (Export Data)",
    importLabel: "डेटा आयात करा (Import Data)",
    resetLabel: "डेटा रीसेट करा (Reset Data)",
    backBtn: "मुख्यपृष्ठावर परत या",
    nityapathHeader: "माझे नित्यपाठ",
    nityapathEmpty: "कोणतीही पाने निवडलेली नाहीत. खालील यादीतून जोडा.",
    nityapathAddHeader: "नवीन नित्यपाठ जोडा",
    nityapathSearchPlaceholder: "आरती किंवा स्तोत्र शोधा...",
    addedBadge: "जोडले आहे",
    addBtn: "+ जोडा",
    quickAccess: "लोकप्रिय",
    recentReads: "तुम्ही अलीकडे वाचलेले",
    recentEmpty: "आपले अलीकडील वाचन येथे दिसेल.",
    dailyPath: "माझा नित्यपाठ",
    dailyPathStart: "नित्यपाठ सुरू करा",
    dailyPathSetup: "नित्यपाठ निवडा",
    removeDailyPathItem: "नित्यपाठातून काढा",
    bookmarkAdd: "आवडीत जोडा",
    bookmarkRemove: "आवडीतून काढा",
    dailyPathAdd: "नित्यपाठात जोडा",
    dailyPathRemove: "नित्यपाठातून काढा",
    deitySection: "देवानुसार वाचा",
    categorySection: "सामग्रीनुसार वाचा",
    searchPrompt: "आरती, स्तोत्र किंवा देवतेचे नाव शोधा.",
    searchNoResults: "काहीही आढळले नाही. वेगळे शब्द वापरून पहा.",
    searchResultsLabel: "परिणाम",
    searchPopularReads: "लोकप्रिय वाचन",
    clearSearch: "शोध मिटवा",
    favSection: "❤️ माझे आवडते",
    favEmpty: "आपली आवडती पाने येथे दिसतील.",
    moreLink: "अधिक पाहा",
    edit: "संपादित करा",
    jaapHeader: "जप काउंटर",
    mantraSelectLabel: "मंत्र निवडा",
    addMantraLabel: "नवीन मंत्र",
    addMantraPlaceholder: "आपला आवडता मंत्र लिहा",
    addMantraButton: "जोडा",
    myMantras: "माझे मंत्र",
    removeMantra: "मंत्र काढा",
    todayJaap: "आजचा जप",
    todayMalas: "आजची माला",
    dailyGoal: "ध्येय",
    sessionHistory: "सत्र इतिहास",
    statistics: "आकडेवारी",
    streakLabel: "सतत जप दिवस",
    streakMessage: "खूप छान! आपला जप सुरू ठेवा.",
    historyDate: "दिनांक",
    historyMantra: "मंत्र",
    historyJaap: "जप संख्या",
    historyMala: "माला संख्या",
    statsToday: "आज",
    statsWeek: "या आठवड्यात",
    statsMonth: "या महिन्यात",
    statsLifetime: "एकूण",
    listenBtn: "🔊 ऐका",
    stopBtn: "⏹ थांबवा",
    autoScrollBtn: "▶ स्वयंचलित स्क्रोल",
    scrollSpeedControls: "वेग: ",
    audioSpeedLabel: "ऑडिओ गती",
    audioSpeedControls: "गती: ",
    scrollSlow: "हळूवार",
    scrollMedium: "मध्यम",
    scrollFast: "जलद",
    chapterDrawer: "अध्याय यादी",
    prevBtn: "मागील",
    nextBtn: "पुढील",
    pageLabel: "अध्याय",
    searchBookPlaceholder: "या पुस्तकात शोधा...",
    resumeReadPrompt: "मागील वाचनापासून सुरू करा",
    panchangWidgetTitle: "आजचे पंचांग",
    panchangWidgetBadge: "पंचांग",
    panchangLocation: "स्थान",
    dismissBanner: "बंद करा",
    muhurtLabel: "मुहूर्त",
    compassLabel: "कम्पास",
    masa: "मास",
    pakshaLabel: "पक्ष",
    tithiLabel: "तिथि",
    nakshatraLabel: "नक्षत्र",
    selectDateTitle: "प्रवचन दिनांक निवडा",
    monthLabel: "महिना",
    dayLabel: "दिवस",
    verified: "सत्यापित",
    unverified: "पडताळणी प्रलंबित",
    verifiedDetailTitle: "अधिकृत स्रोत सत्यापित",
    verifiedDetailDesc: "हे पान एका अधिकृत आणि विश्वासार्ह स्रोताकडून पडताळले गेले आहे.",
    unverifiedDetailTitle: "पडताळणी प्रलंबित",
    unverifiedDetailDesc: "या पानाची पडताळणी अजून पूर्ण झालेली नाही.",
    close: "बंद करा",
    updatesTitle: "नवीन बदल आणि अपडेट्स",
    updatesHeader: "ॲप अपडेट्स",
    updatesTab: "अपडेट्स",
    loadingUpdates: "माहिती लोड होत आहे...",
    retryUpdates: "पुन्हा प्रयत्न करा",
    currentVersionLabel: "तुमची सध्याची आवृत्ती:",
    latestVersionLabel: "नवीन उपलब्ध आवृत्ती:",
    appUpToDate: "तुमचे ॲप अद्ययावत आहे",
    updateAvailable: "नवीन अपडेट उपलब्ध आहे! पेज अद्ययावत करण्यासाठी कृपया रीफ्रेश करा.",
  },
  en: {
    appTitle: "Sangrah",
    appSubtitle: "Complete Spiritual Devotional Book",
    homeTab: "Home",
    searchTab: "Search",
    jaapTab: "Jaap",
    favTab: "Favorites",
    settingsTab: "Settings",
    historyTab: "History",
    settingsHeader: "Settings",
    langLabel: "Language",
    themeLabel: "Theme",
    themeLight: "Light Mode",
    themeDark: "Dark Mode",
    elderModeLabel: "Senior Citizen Mode",
    elderModeHelp: "Enable larger fonts, larger buttons, and increased spacing.",
    fontSizeLabel: "Font Size",
    scrollSpeedLabel: "Auto Scroll Speed",
    offlineLabel: "Offline Management",
    offlineHelp: "✅ Available Offline",
    exportLabel: "Export Data",
    importLabel: "Import Data",
    resetLabel: "Reset Data",
    backBtn: "Return to Home",
    nityapathHeader: "My Daily Path",
    nityapathEmpty: "No daily paths selected. Add below.",
    nityapathAddHeader: "Add New Daily Path",
    nityapathSearchPlaceholder: "Search prayers...",
    addedBadge: "Added",
    addBtn: "+ Add",
    quickAccess: "Popular",
    recentReads: "Recently Read",
    recentEmpty: "Your recently read prayers will appear here.",
    dailyPath: "Daily Path",
    dailyPathStart: "Start Daily Path",
    dailyPathSetup: "Choose readings",
    removeDailyPathItem: "Remove from Daily Path",
    bookmarkAdd: "Add to favorites",
    bookmarkRemove: "Remove from favorites",
    dailyPathAdd: "Add to Daily Path",
    dailyPathRemove: "Remove from Daily Path",
    deitySection: "Browse by Deity",
    categorySection: "Browse by Category",
    searchPrompt: "Search for an aarti, stotra, or deity.",
    searchNoResults: "No results found. Try different words.",
    searchResultsLabel: "results",
    searchPopularReads: "Popular readings",
    clearSearch: "Clear search",
    favSection: "❤️ Favorites",
    favEmpty: "Your favorite pages will appear here.",
    moreLink: "More",
    edit: "Edit",
    jaapHeader: "Jaap Counter",
    mantraSelectLabel: "Select Mantra",
    addMantraLabel: "New mantra",
    addMantraPlaceholder: "Enter your favourite mantra",
    addMantraButton: "Add",
    myMantras: "My mantras",
    removeMantra: "Remove mantra",
    todayJaap: "Today's Jaap",
    todayMalas: "Today's Malas",
    dailyGoal: "Daily Goal",
    sessionHistory: "Session History",
    statistics: "Statistics",
    streakLabel: "Continuous Streak",
    streakMessage: "Keep up the spiritual practice!",
    historyDate: "Date",
    historyMantra: "Mantra",
    historyJaap: "Jaap Count",
    historyMala: "Malas",
    statsToday: "Today",
    statsWeek: "This Week",
    statsMonth: "This Month",
    statsLifetime: "Lifetime Total",
    listenBtn: "🔊 Listen",
    stopBtn: "⏹ Stop",
    autoScrollBtn: "▶ Auto Scroll",
    scrollSpeedControls: "Speed: ",
    audioSpeedLabel: "Audio Speed",
    audioSpeedControls: "Speed: ",
    scrollSlow: "Slow",
    scrollMedium: "Medium",
    scrollFast: "Fast",
    chapterDrawer: "Chapters",
    prevBtn: "Previous",
    nextBtn: "Next",
    pageLabel: "Chapter",
    searchBookPlaceholder: "Search within book...",
    resumeReadPrompt: "Resume from last read",
    panchangWidgetTitle: "Today’s Panchang",
    panchangWidgetBadge: "Panchang",
    panchangLocation: "Location",
    dismissBanner: "Dismiss",
    muhurtLabel: "Muhurt",
    compassLabel: "Compass",
    masa: "Masa",
    pakshaLabel: "Paksha",
    tithiLabel: "Tithi",
    nakshatraLabel: "Nakshatra",
    selectDateTitle: "Select Pravachan Date",
    monthLabel: "Month",
    dayLabel: "Day",
    verified: "Verified",
    unverified: "Pending Verification",
    verifiedDetailTitle: "Verified with Authoritative Source",
    verifiedDetailDesc: "This page content has been verified with an authoritative source.",
    unverifiedDetailTitle: "Pending Verification",
    unverifiedDetailDesc: "This page content is pending verification.",
    close: "Close",
    updatesTitle: "New Changes & Updates",
    updatesHeader: "App Updates",
    updatesTab: "Updates",
    loadingUpdates: "Loading updates...",
    retryUpdates: "Retry",
    currentVersionLabel: "Your Current Version:",
    latestVersionLabel: "Latest Available Version:",
    appUpToDate: "Your app is up to date",
    updateAvailable: "New update available! Please refresh the page to update.",
  },
  hi: {
    appTitle: "संपूर्ण संग्रह",
    appSubtitle: "आध्यात्मिक वाचन का संपूर्ण संग्रह",
    homeTab: "होम",
    searchTab: "खोजें",
    jaapTab: "जाप",
    favTab: "पसंदीदा",
    settingsTab: "सेटिंग्स",
    historyTab: "इतिहास",
    settingsHeader: "सेटिंग्स",
    langLabel: "भाषा",
    themeLabel: "थीम",
    themeLight: "लाइट मोड",
    themeDark: "डार्क मोड",
    elderModeLabel: "वरिष्ठ नागरिक मोड",
    elderModeHelp: "बड़े अक्षरों, बड़े बटनों और अधिक दूरी को सक्षम करें।",
    fontSizeLabel: "अक्षर आकार",
    scrollSpeedLabel: "स्वचालित स्क्रॉल गति",
    offlineLabel: "ऑफ़लाइन प्रबंधन",
    offlineHelp: "✅ ऑफ़लाइन उपलब्ध",
    exportLabel: "डेटा निर्यात करें",
    importLabel: "डेटा आयात करें (Import Data)",
    resetLabel: "डेटा रीसेट करें",
    backBtn: "मुख्य पृष्ठ पर जाएं",
    nityapathHeader: "मेरा नित्यपाठ",
    nityapathEmpty: "कोई पाठ नहीं चुना गया। नीचे दी गई सूची से जोड़ें।",
    nityapathAddHeader: "नया नित्यपाठ जोड़ें",
    nityapathSearchPlaceholder: "आरती या स्तोत्र खोजें...",
    addedBadge: "जोड़ा गया",
    addBtn: "+ जोड़ें",
    quickAccess: "लोकप्रिय",
    recentReads: "हाल ही में पढ़ा गया",
    recentEmpty: "आपके हाल ही में पढ़े गए पाठ यहाँ दिखाई देंगे।",
    dailyPath: "मेरा नित्यपाठ",
    dailyPathStart: "नित्यपाठ शुरू करें",
    dailyPathSetup: "नित्यपाठ चुनें",
    removeDailyPathItem: "नित्यपाठ से हटाएं",
    bookmarkAdd: "पसंदीदा में जोड़ें",
    bookmarkRemove: "पसंदीदा से हटाएं",
    dailyPathAdd: "नित्यपाठ में जोड़ें",
    dailyPathRemove: "नित्यपाठ से हटाएं",
    deitySection: "भगवान के अनुसार पढ़ें",
    categorySection: "सामग्री के अनुसार पढ़ें",
    searchPrompt: "आरती, स्तोत्र या भगवान का नाम खोजें।",
    searchNoResults: "कुछ नहीं मिला। अलग शब्दों से खोजें।",
    searchResultsLabel: "परिणाम",
    searchPopularReads: "लोकप्रिय पाठ",
    clearSearch: "खोज साफ़ करें",
    favSection: "❤️ पसंदीदा",
    favEmpty: "आपके पसंदीदा पाठ यहाँ दिखाई देंगे।",
    moreLink: "अधिक देखें",
    edit: "संपादित करें",
    jaapHeader: "जाप काउंटर",
    mantraSelectLabel: "मंत्र चुनें",
    addMantraLabel: "नया मंत्र",
    addMantraPlaceholder: "अपना पसंदीदा मंत्र लिखें",
    addMantraButton: "जोड़ें",
    myMantras: "मेरे मंत्र",
    removeMantra: "मंत्र हटाएं",
    todayJaap: "आज का जाप",
    todayMalas: "आज की माला",
    dailyGoal: "लक्ष्य",
    sessionHistory: "सत्र इतिहास",
    statistics: "आंकेड़े",
    streakLabel: "सतत जाप दिन",
    streakMessage: "बहुत बढ़िया! अपना जाप जारी रखें।",
    historyDate: "दिनांक",
    historyMantra: "मंत्र",
    historyJaap: "जाप संख्या",
    historyMala: "माला संख्या",
    statsToday: "आज",
    statsWeek: "इस सप्ताह",
    statsMonth: "इस महीने",
    statsLifetime: "कुल",
    listenBtn: "🔊 सुनें",
    stopBtn: "⏹ रोकें",
    autoScrollBtn: "▶ स्वचालित स्क्रॉल",
    scrollSpeedControls: "गति: ",
    audioSpeedLabel: "ऑडियो गति",
    audioSpeedControls: "गति: ",
    scrollSlow: "धीमा",
    scrollMedium: "मध्यम",
    scrollFast: "तेज",
    chapterDrawer: "अध्याय सूची",
    prevBtn: "पिछला",
    nextBtn: "अगला",
    pageLabel: "अध्याय",
    searchBookPlaceholder: "इस पुस्तक में खोजें...",
    resumeReadPrompt: "पिछली बार पढ़े गए स्थान से शुरू करें",
    panchangWidgetTitle: "आज का पंचांग",
    panchangWidgetBadge: "पंचांग",
    panchangLocation: "स्थान",
    dismissBanner: "बंद करें",
    muhurtLabel: "मुहूर्त",
    compassLabel: "कम्पास",
    masa: "मास",
    pakshaLabel: "पक्ष",
    tithiLabel: "तिथि",
    nakshatraLabel: "नक्षत्र",
    selectDateTitle: "प्रवचन दिनांक चुनें",
    monthLabel: "माह",
    dayLabel: "दिन",
    verified: "सत्यापित",
    unverified: "सत्यापन लंबित",
    verifiedDetailTitle: "प्रामाणिक स्रोत सत्यापित",
    verifiedDetailDesc: "यह पृष्ठ एक प्रामाणिक और विश्वसनीय स्रोत से सत्यापित किया गया है।",
    unverifiedDetailTitle: "सत्यापन लंबित",
    unverifiedDetailDesc: "इस पृष्ठ का सत्यापन अभी पूर्ण नहीं हुआ है।",
    close: "बंद करें",
    updatesTitle: "नए बदलाव और अपडेट्स",
    updatesHeader: "ऐप अपडेट्स",
    updatesTab: "अपडेट्स",
    loadingUpdates: "अपडेट लोड हो रहे हैं...",
    retryUpdates: "पुनः प्रयास करें",
    currentVersionLabel: "आपका वर्तमान संस्करण:",
    latestVersionLabel: "नवीनतम उपलब्ध संस्करण:",
    appUpToDate: "आपका ऐप अपडेटेड है",
    updateAvailable: "नया अपडेट उपलब्ध है! कृपया पेज रीफ्रेश करें।",
  }
};

const fallbackLang = (code) => {
  if (translations[code]) return code;
  if (['sa', 'gu', 'kn', 'te', 'ta', 'ml', 'bn'].includes(code)) return 'hi';
  return 'mr';
};

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('mr');

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const stored = window.localStorage.getItem('site-language') || 'mr';
    setLang(stored);
  }, []);

  const changeLanguage = (newLang) => {
    setLang(newLang);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('site-language', newLang);
    }
  };

  const t = (key) => {
    const activeLang = fallbackLang(lang);
    return translations[activeLang][key] || translations['mr'][key] || key;
  };

  const translateNumbers = (value) => {
    if (value === undefined || value === null) return '';
    const numStr = value.toString();
    if (lang !== 'mr' && lang !== 'hi') return numStr;
    const devanagariDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return numStr.replace(/[0-9]/g, (digit) => devanagariDigits[parseInt(digit, 10)]);
  };

  return (
    <LanguageContext.Provider value={{ lang, changeLanguage, t, translateNumbers }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}
